<div class="header" [formGroup]="filterForm">
  <app-input-wrapper [control]="filterForm.controls['searchTerm']">
    <app-icon input-wrapper-icon-start name="ic_search" />
    <input
      type="search"
      formControlName="searchTerm"
      [placeholder]="'default.search' | translate"
    />
  </app-input-wrapper>

  <button
    type="button"
    class="button primary-button icon-button"
    (click)="create.emit()"
  >
    <app-icon name="ic_plus" />
    {{ "deviceGroups.form.title.create" | translate }}
  </button>
</div>
<div class="header">
  <br />
  <button type="button" class="button icon-button" (click)="toggleView()">
    @if (isListView) {
      <app-icon name="ic_list"></app-icon>
      {{ "default.view.list" | translate }}
    } @else {
      <app-icon name="ic_tiles"></app-icon>
      {{ "default.view.tiles" | translate }}
    }
  </button>
</div>
@if (isListView) {
  <div class="content grid grid-cols-auto">
    @if (deviceGroupsView$ | async; as views) {
      @for (view of views; track view.deviceGroup.id) {
        <app-area-item-card
          [deviceGroup]="view.deviceGroup"
          [isExpanded]="expandedById?.[view.deviceGroup.id] === true"
          (isExpandedChange)="onGroupExpandedChange(view.deviceGroup.id, $event)"
        />
      } @empty {
        <div class="span-full">{{ "devices.empty" | translate }}</div>
      }
    }
  </div>
} @else {
  <div class="content">
    <table>
      @if (deviceGroupsView$ | async; as views) {
        @for (view of views; track view.deviceGroup.id) {
          <tr
            class="parent-row"
            [class.expanded]="expandedById?.[view.deviceGroup.id] === true"
            app-area-item-row
            [isExpanded]="expandedById?.[view.deviceGroup.id] === true"
            (isExpandedChange)="onGroupExpandedChange(view.deviceGroup.id, $event)"
            [deviceGroup]="view.deviceGroup"
            (triggerAction)="triggerAction.emit($event)"
            (edit)="edit.emit($event)"
            (delete)="delete.emit($event)"
          ></tr>
          @if (expandedById?.[view.deviceGroup.id] === true) {
            @for (device of view.devices; track device.id) {
              <tr
                class="child-row"
                app-device-item-row
                [device]="device"
                [hideActions]="true"
              ></tr>
            }
          }
        } @empty {
          <tr>
            <td colspan="4">{{ "devices.empty" | translate }}</td>
          </tr>
        }
      } @else {
        <tr>
          <td colspan="4">{{ "devices.empty" | translate }}</td>
        </tr>
      }

      <!--thead>
        <tr app-area-item-row [isHeader]="true"></tr>
      </thead>
      <tbody>
        @for (group of deviceGroups ?? []; track group.id) {
          <tr
            app-area-item-row
            [deviceGroup]="group"
            (edit)="edit.emit($event)"
            (delete)="delete.emit($event)"
          ></tr>
        } @empty {
          <tr>
            <td colspan="4">{{ 'devices.empty' | translate }}</td>
          </tr>
        }
      </tbody-->
    </table>
  </div>
}
<div class="footer">
  <app-pagination
    [pageSize]="filterForm.value.pageSize ?? 12"
    [totalCount]="totalCount"
    [currentPage]="filterForm.value.page ?? 0"
    [loading]="loading"
    (pageChange)="onChangePage($event)"
  />
</div>
